var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    {
      staticClass: "mb-3",
      attrs: { cols: "12", md: "6", lg: "4", flip: "flop" },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "title font-weight-black" },
            [
              _c("v-icon", { staticClass: "pr-3" }, [_vm._v("today")]),
              _vm._v(" Calendar Items Today\n        "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _vm.loading ? _c("div", [_vm._v("Loading...")]) : _vm._e(),
              _vm._v(" "),
              _c(
                "v-list",
                [
                  _vm._l(_vm.notifications, function (item, index) {
                    return [
                      _c(
                        "v-list-item",
                        { key: index, attrs: { ripple: "", href: item.url } },
                        [
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "list__item__subtitle" },
                            [
                              _c(
                                "a",
                                { attrs: { href: _vm.getItemUrl(item) } },
                                [
                                  item.user
                                    ? _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            item.user.first_name +
                                              " " +
                                              item.user.surname +
                                              " - "
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(
                                    " " +
                                      _vm._s(item.start_time) +
                                      " - " +
                                      _vm._s(item.end_time) +
                                      ": " +
                                      _vm._s(item.subject) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              item.user && item.user.email
                                ? _c(
                                    "a",
                                    { attrs: { href: _vm.getEmailUrl(item) } },
                                    [_c("v-icon", [_vm._v("email")])],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      index + 1 < _vm.data.length
                        ? _c("v-divider", { key: index })
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                { attrs: { disabled: "" } },
                [_c("v-icon", [_vm._v("add")]), _vm._v(" Add New")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { href: "/calendar-events/list" } },
                [_c("v-icon", [_vm._v("list")]), _vm._v(" See Full List")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { href: "/calendar-events/calendar", disabled: "" } },
                [_c("v-icon", [_vm._v("today")]), _vm._v(" See Full Calendar")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }